<template>
  <div>
    <div class="verbal-process-group">
      <div class="form-group">
        <b>Data procesului verbal</b>
        <date-picker
          v-model="verbalProcess.verbalProcessDate"
          type="date"
          format="DD-MM-YYYY"
          valueType="date"
          popup-class="bigger-index"
          :disabled="true"
        />
      </div>
      <div class="form-group">
        <b>Criteriul de atribuire</b>
        <v-select
          v-model="verbalProcess.attributionCriteria"
          :options="[
            'Preţul cel mai scăzut',
            'Costul cel mai scăzut',
            'Cel mai bun raport calitate-preţ',
            'Cel mai bun raport calitate-cost',
          ]"
        >
        </v-select>
      </div>
    </div>

    <div class="verbal-process-group">
      <div class="form-group">
        <b
          >Modalitatea de solicitare / obținere oferte financiare și tehnice:</b
        >

        <v-select
          v-model="verbalProcess.requestModality"
          :options="infoModality"
        >
        </v-select>
      </div>
      <div class="form-group">
        <b>Modalitatea de primire / obținere oferte financiare și tehnice:</b>

        <v-select
          v-model="verbalProcess.receiveModality"
          :options="infoModality"
        >
        </v-select>
      </div>
    </div>
    <div class="verbal-process-group">
      <div class="form-group">
        <b>Reasponsabil procedură (Membru 1):</b>
        <input style="width: 100%" :value="member1" :disabled="true" />
      </div>
    </div>
    <div class="verbal-process-group">
      <div class="form-group">
        <b>Reasponsabil procedură (Membru 2):</b>
        <v-select
          v-model="verbalProcess.memberRole[0]"
          :options="memberRolesView"
        >
        </v-select>
      </div>
      <div class="form-group">
        <b>Reasponsabil procedură (Membru 3):</b>
        <v-select
          v-model="verbalProcess.memberRole[1]"
          :options="memberRolesView"
        >
        </v-select>
      </div>
    </div>

    <div class="verbal-process-group" v-if="!disabledDepartment">
      <div class="form-group">
        <b>Valoarea totală inițială, fără TVA</b>
        <CustomNumberInput
          v-model="verbalProcess.initialTotalValueWithoutTva"
        ></CustomNumberInput>
      </div>
      <div class="form-group">
        <b>Valoarea totală inițială, cu TVA</b>
        <CustomNumberInput
          v-model="verbalProcess.initialTotalValueWithTva"
        ></CustomNumberInput>
      </div>
    </div>

    <div class="verbal-process-group">
      <div class="form-group">
        <b>Departamentele achiziției</b>
        <v-select
          v-model="verbalProcess.departments"
          label="name"
          :options="departments"
          :appendToBody="true"
          :multiple="true"
          :disabled="disabledDepartment"
        >
        </v-select>
      </div>
    </div>

    <div>
      <div
        v-for="(item, index) of verbalProcess.verbalProcessInstitutionProvider"
        :key="index"
      >
        <b>Oferta {{ index + 1 }} </b>

        <div class="verbal-process-container">
          <i
            @click="deleteProvider(index, item)"
            v-tooltip="'Șterge furnizor'"
            class="fas fa-minus-circle delete-provider-icon"
            style="cursor: pointer; color: red"
          ></i>
          <div class="verbal-process-group">
            <div class="verbal-process">
              <div>
                <b>CUI furnizor</b>
              </div>
              <div class="RForm">
                <input
                  type="text"
                  class="vInput"
                  v-model="item.institutionProviderCui"
                  @keydown.tab="getByCui(index)"
                />
                <i @click="getByCui(index)" class="fas fa-search"></i>
              </div>
            </div>
            <div class="form-group noMB">
              <b>Nume furnizor</b>
              <input
                type="text"
                class="vInput form-disabled"
                v-model="item.institutionProviderName"
                :disabled="true"
              />
            </div>
          </div>
          <div class="verbal-process-group" style="margin-top: 10px">
            <div class="form-group noMB">
              <b>Valoare totală fără TVA</b>
              <CustomNumberInput
                v-model="item.totalValueWithoutTva"
                @input="updateTotalValueWithTva(index)"
              ></CustomNumberInput>
            </div>

            <div class="form-group noMB">
              <b>Cotă TVA</b>
              <input
                min="0"
                max="100"
                type="text"
                class="vInput procent"
                v-model="item.tvaValue"
                @input="($event) => updateTva($event, index)"
              />
            </div>

            <div class="form-group noMB">
              <b>Valoare totală cu TVA</b>
              <CustomNumberInput
                v-model="item.totalValueWithTva"
                :disabled="true"
              ></CustomNumberInput>
            </div>
          </div>
          <div
            style="
              margin-top: 8px;
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
            "
          >
            <div>
              <b>ANEXE</b>
              <br />
              <label
                class="input-file-computer-label"
                :for="'verbal_process_' + index"
              >
                <i class="fas fa-laptop"></i>
                Computer
              </label>
              <input
                :id="'verbal_process_' + index"
                type="file"
                style="display: none"
                @change="(event) => onUploadFiles(event.target.files, index)"
              />
            </div>
            <div style="min-width: 200px">
              <v-select
                v-model="item.evaluationResult"
                :options="evaluationOptions(index)"
                :reduce="(option) => option.value"
                append-to-body
              >
              </v-select>
            </div>
          </div>

          <div style="margin-top: 10px">
            <div
              v-for="(doc, j) in item.annexes"
              :key="j"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div>{{ doc.name || doc.key }}</div>
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  cursor: pointer;
                "
              >
                <div style="display: flex; align-items: center">
                  <i
                    v-tooltip="{ content: 'Deschide fișier' }"
                    style="color: #337ab7"
                    class="fas fa-external-link-alt"
                    @click="viewOffer(doc, item)"
                  ></i>
                </div>
                <div
                  v-if="verbalProcess.status == 'draft'"
                  style="margin: 0px 10px"
                >
                  |
                </div>
                <div
                  v-if="verbalProcess.status == 'draft'"
                  style="display: flex; align-items: center; cursor: pointer"
                >
                  <i
                    v-tooltip="{ content: 'Șterge fișier' }"
                    style="color: #ec4a4a"
                    class="fas fa-trash"
                    @click="deleteOffer(index, item.id, j, doc)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="verbalProcess.verbalProcessInstitutionProvider.length < 5"
      style="display: flex; justify-content: flex-end"
      @click="addProvider"
    >
      <i
        v-tooltip="'Adaugă furnizor'"
        class="fas fa-plus-circle"
        style="cursor: pointer; color: #39f"
      ></i>
    </div>
  </div>
</template>
<script>
import DialogModal from "@/components/DialogModal";
import DatePicker from "@/mixins/DatePicker.js";
import CustomNumberInput from "@/components/CustomNumberInput";
import {
  USERS_INSTITUTION,
  INSTITUTION_PROVIDERS,
  VERBAL_PROCESS,
  DEPARTMENT,
} from "../api.js";
import { v4 as uuidv4 } from "uuid";
import { mapMutations } from "vuex";
import {
  OfferEvaluationResult,
  OfferEvaluationResultOptions,
} from "../common/types/offer-evaluation-result.type";

const DEFAULT_OFFER = () => ({
  totalValueWithoutTva: "",
  tvaValue: "",
  totalValueWithTva: "",
  institutionProviderName: "",
  institutionProviderCui: "",
  annexes: [],
  evaluationResult: "",
});

export default {
  mixins: [DatePicker],
  components: { CustomNumberInput },
  props: {
    initial: {
      type: Object,
      default: () => null,
    },
    needReferences: {
      type: Array | String,
      required: false,
    },
  },
  data() {
    return {
      EVALUATION_RESULT_TYPES: OfferEvaluationResultOptions,
      departments: [],
      member1: null,
      memberRoles: [],
      infoModality: [
        "E-mail/Telefonic/Fax/Adrese",
        "Studiu de piață/Cataloage/Internet",
        "Catalog electronic S.E.A.P",
      ],
      verbalProcess: {
        status: "draft",
        verbalProcessDate: new Date(),
        requestModality: "",
        receiveModality: "",
        attributionCriteria: "",
        memberRole: [],
        verbalProcessInstitutionProvider: [
          DEFAULT_OFFER(),
          DEFAULT_OFFER(),
          DEFAULT_OFFER(),
        ],
        departments: [],
        initialTotalValueWithoutTva: "",
        initialTotalValueWithTva: "",
      },
    };
  },

  watch: {
    verbalProcess: {
      handler(val) {
        this.$emit("input", {
          ...val,
          verbalProcessInstitutionProvider:
            val.verbalProcessInstitutionProvider.map((el) => ({
              ...el,
              tvaValue: this.removePercentage(el.tvaValue),
            })),
        });
      },
      deep: true,
      immediate: true,
    },
    deep: true,
    immediate: true,
  },
  computed: {
    memberRolesView() {
      return this.memberRoles.filter(
        (el) =>
          el._userId != this.verbalProcess.memberRole[0]?._userId &&
          el._userId != this.verbalProcess.memberRole[1]?._userId &&
          el.id != this.getUserRole(true),
      );
    },

    disabledDepartment() {
      return (
        (Array.isArray(this.needReferences) &&
          this.needReferences.length > 0) ||
        this.needReferences === "all" ||
        (this.initial && this.initial.numberOfReferences > 0)
      );
    },
  },
  methods: {
    ...mapMutations(["addWindow"]),

    async createBase64Image(fileObject) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(fileObject);
      });
    },
    async onUploadFiles(files, index) {
      const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
      const MAX_ANNEXES = 5;

      const currentAnnexes =
        this.verbalProcess.verbalProcessInstitutionProvider[index].annexes ||
        [];

      for (const file of files) {
        if (file.size > MAX_FILE_SIZE) {
          this.$toastr.e(`Fișierul "${file.name}" depășește limita de 5MB.`);
          continue;
        }

        if (currentAnnexes.length >= MAX_ANNEXES) {
          this.$toastr.e(
            `Nu puteți încărca mai mult de ${MAX_ANNEXES} anexe per ofertă.`,
          );
          break;
        }

        const fileType = file.type.split("/");

        const key = `${file.size}-${uuidv4()}.${fileType[fileType.length - 1]}`;

        const base64 = await this.createBase64Image(file);

        if (
          !this.verbalProcess.verbalProcessInstitutionProvider[index].annexes
        ) {
          this.verbalProcess.verbalProcessInstitutionProvider[index].annexes = [
            { name: file.name, key, base64, file },
          ];
        } else {
          this.verbalProcess.verbalProcessInstitutionProvider[
            index
          ].annexes.push({ name: file.name, key, base64, file });
        }
      }

      this.$forceUpdate();
    },
    getByCui(index) {
      const institutionProviderCui =
        this.verbalProcess.verbalProcessInstitutionProvider[index]
          .institutionProviderCui;

      const error = (msg) => {
        this.$toastr.e(msg || "Furnizorul nu a fost gasit.");
        this.verbalProcess.verbalProcessInstitutionProvider[
          index
        ].institutionProviderName = "";
        this.setLoad(false);
      };

      this.setLoad(true);

      INSTITUTION_PROVIDERS.getByCui(institutionProviderCui)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.verbalProcess.verbalProcessInstitutionProvider[
              index
            ].institutionProviderName = res.data.name;
            this.setLoad(false);
          } else {
            error(res?.data?.response || null);
          }
        })
        .catch(error);
    },

    updateTva(event, index) {
      let tvaValue =
        this.verbalProcess.verbalProcessInstitutionProvider[index].tvaValue;

      if (event.inputType == "deleteContentBackward" && tvaValue) {
        tvaValue = tvaValue.slice(0, -1);
        tvaValue += "%";
      } else {
        event.target.value = this.removePercentage(event.target.value);

        tvaValue = event.target.value.match(/^\d+\.?\d{0,2}$/);

        if (tvaValue) {
          tvaValue += "%";
        }
      }

      this.verbalProcess.verbalProcessInstitutionProvider[index].tvaValue =
        tvaValue;

      this.updateTotalValueWithTva(index);
    },

    updateTotalValueWithTva(index) {
      let tvaValue =
        this.verbalProcess.verbalProcessInstitutionProvider[index].tvaValue;

      const totalValueWithoutTva =
        this.verbalProcess.verbalProcessInstitutionProvider[index]
          .totalValueWithoutTva;

      let totalValueWithTva = this.exactRound(
        this.prepareTva(totalValueWithoutTva, this.removePercentage(tvaValue)),
      );

      this.verbalProcess.verbalProcessInstitutionProvider[
        index
      ].totalValueWithTva = totalValueWithTva;
    },

    removePercentage(val) {
      if (!val) return "";
      return val.replace("%", "");
    },

    deleteProvider(index, item) {
      const error = (msg) => {
        this.$toastr.e(msg || "Documentul nu a fost șters.");
        this.setLoad();
      };

      if (
        !this.verbalProcess.verbalProcessInstitutionProvider ||
        this.verbalProcess.verbalProcessInstitutionProvider.length < 4
      ) {
        error("Trebuie păstrate cel puțin 3 oferte.");
        return;
      }

      if (!item.id) {
        this.verbalProcess.verbalProcessInstitutionProvider.splice(index, 1);
        return;
      }

      this.$modal.show(
        DialogModal,
        {
          target: "DeleteOffer",
          title: "Șterge ofertă",
          content: `<h4>Sunteți sigur că ștergeți această ofertă?</h4>`,
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              VERBAL_PROCESS.deleteProvider(this.initial.id, item.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Oferta a fost ștearsă.");

                    this.verbalProcess.verbalProcessInstitutionProvider.splice(
                      index,
                      1,
                    );
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "DeleteOffer",
          adaptive: true,
          width: "650",
          height: "400",
        },
      );
    },
    addProvider() {
      this.verbalProcess.verbalProcessInstitutionProvider.push(DEFAULT_OFFER());
    },

    evaluationOptions(index) {
      const someoneElseWon =
        this.verbalProcess.verbalProcessInstitutionProvider.some(
          (offer, i) =>
            i !== index &&
            offer.evaluationResult === OfferEvaluationResult.WINNER,
        );

      return this.EVALUATION_RESULT_TYPES.filter(
        (option) =>
          option.value !== OfferEvaluationResult.WINNER || !someoneElseWon,
      );
    },

    async getUsers() {
      const role = await this.getBeautifiedRole();

      const name = await this.getUserName();

      const u = await this.getToken();

      this.member1 = `${name} / ${u.id} - ${role}`;

      USERS_INSTITUTION()
        .then((res) => {
          if (Array.isArray(res?.data?.result)) {
            this.memberRoles = res.data.result
              .flatMap(
                (e) =>
                  e?.userRoles?.map((i) => {
                    if (i && i.role == "responsabil_achizitii") {
                      return {
                        ...i,
                        id: i.id ?? this.makeid(6),
                        _userId: e.id,
                        label:
                          this.readUserObject(e) +
                          (i.department?.name
                            ? ` — ${i.department?.name}`
                            : "") +
                          (i.role ? ` — ${this.changeRoleView(i.role)}` : ""),
                        user: {
                          uuid: e.uuid,
                          id: e.id,
                          first_name: e.first_name,
                          last_name: e.last_name,
                        },
                      };
                    }
                    return null;
                  }) || [],
              )
              .filter((el) => el)
              .sort((a, b) => a.label - b.label);
          }
        })
        .catch();
    },

    async deleteOffer(index, offerId, offerIndex, annexe) {
      if (annexe.base64) {
        this.verbalProcess.verbalProcessInstitutionProvider[
          index
        ].annexes.splice(offerIndex, 1);
      } else {
        const error = (msg) => {
          this.$toastr.e(msg || "Documentul nu a fost șters.");
          this.setLoad();
        };

        this.$modal.show(
          DialogModal,
          {
            target: "DeleteDOC",
            title: "Șterge document",
            content: `<h4>Sunteți sigur că ștergeți acest document?</h4>`,
            closeBtnText: "Anulează",
            button: {
              type: 3,
              value: "Șterge",
              handler: () => {
                VERBAL_PROCESS.deleteOfferAnnexe(this.initial.id, offerId, {
                  fileKey: annexe.key,
                })
                  .then((res) => {
                    if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                      this.$toastr.s("Documentul a fost șters.");

                      this.verbalProcess.verbalProcessInstitutionProvider[
                        index
                      ].annexes.splice(offerIndex, 1);
                      this.setLoad();
                    } else {
                      error(res.response);
                    }
                  })
                  .catch(error);
              },
            },
          },
          {
            name: "DeleteDOC",
            adaptive: true,
            width: "650",
            height: "400",
          },
        );
      }
      this.$forceUpdate();
    },

    viewOffer(annexe, offer) {
      if (!this.initial) {
        this.$toastr.w("Fișierul poate fi vizualizat după salvare.");
      }
      
      this.addWindow(
        Object.assign({
          fileList: [annexe.key],
          fileNames: { [annexe.key]: annexe.name || annexe.key },
          itemId: offer.id,
          canDelete: false,
          modal: 13,
          select: 0,
          searchModuleApi: VERBAL_PROCESS.getOfferAnnexe,
          isBlob: annexe.file,
        }),
      );
    },
  },
  created() {
    this.getUsers();

    if (this.initial) {
      this.verbalProcess = {
        ...this.initial,
        verbalProcessDate: new Date(this.initial.verbalProcessDate),
      };

      this.verbalProcess.verbalProcessInstitutionProvider =
        this.verbalProcess.verbalProcessInstitutionProvider.map((el) => {
          return {
            ...el,
            tvaValue: el.tvaValue + "%",
            institutionProviderName: el.institutionProvider.name,
            institutionProviderCui: el.institutionProvider.cui,
          };
        });
    }

    if (
      (Array.isArray(this.needReferences) &&
        this.needReferences.length === 0) ||
      (this.initial && this.initial.numberOfReferences === 0)
    ) {
      DEPARTMENT().then((res) => {
        if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
          this.departments = res.data.result;
        }
      });
    } else if (
      Array.isArray(this.needReferences) &&
      this.needReferences.length > 0
    ) {
      this.departments = [
        ...new Map(
          this.needReferences.map((el) => [el.department.id, el.department]),
        ).values(),
      ];
      this.verbalProcess.departments = this.departments;
    }
  },
};
</script>
<style lang="scss">
.verbal-process-group {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: space-between;
  .form-group {
    flex: 1;
  }
}
.verbal-process-container {
  border: 1px solid;
  border-radius: 5px;
  padding: 10px;
  position: relative;
  margin-bottom: 10px;
  .delete-provider-icon {
    display: none;
    position: absolute;
    top: -8px;
    right: -7px;
    background-color: white;
  }
}

.verbal-process-container:hover {
  .delete-provider-icon {
    display: initial;
  }
}
.input-file-computer-label {
  background-color: #5bc0de;
  color: white;
  width: fit-content;
  padding: 2px 5px;
  border-radius: 3px;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
}
</style>